
import React, { memo, useEffect, useState } from 'react'
import CustomPressable from '../customPressable/customPressable';
import { View } from 'react-native';
import { ImageComp } from '../Image/Image';
import CustomFlatList from '../customFlatList';
import { useCssStyle } from '../../customHook/getCssStyle';
import { getCleanUrl } from '../../utils/Helper';
import useWidgetClickHandler from '../../customHook/useWidgetClickHandler';

const FloatingWidget = memo((props) => {
  const { listItemData } = props || {};
  const handleOnWidgetClick = useWidgetClickHandler();
  const getStyles = useCssStyle();


  const renderItem = ({ item }) => (
    <CustomPressable onPress={() => handleOnWidgetClick(item)} style={getStyles(['floatingWidgetsWidgetContainer', `floatingWidgetsWidgetContainer_${item.widgetMetaHtmlId}` ,`floatingWidgetsWidgetContainer_${item.id}`])} id={`floatingWidgetsWidgetContainer floatingWidgetsWidgetContainer_${item.widgetMetaHtmlId} floatingWidgetsWidgetContainer_${item.id}`} >

        <View style={getStyles(['floatingWidgetImageStyle', `floatingWidgetImageStyle_${item.widgetMetaHtmlId}`, `floatingWidgetImageStyle_${item.id}`])} id={`floatingWidgetImageStyle floatingWidgetImageStyle_${item.widgetMetaHtmlId} floatingWidgetImageStyle_${item.id}`}>
            <ImageComp
              source={getCleanUrl(item?.btnImageUrl)}
              style={getStyles(['floatingWidgetImage', `floatingWidgetImage_${item.widgetMetaHtmlId}`, `floatingWidgetImage_${item.id}`])}
              id={`floatingWidgetImage floatingWidgetImage_${item.widgetMetaHtmlId} floatingWidgetImage_${item.id}`}
            />
        </View>
    </CustomPressable>
  );

  const floatingWidgetStyle = getStyles(['floatingWidgetFlatListContentContainer', `floatingWidgetFlatListContentContainer_${listItemData[0]?.widgetMetaHtmlId}`]);

  return (
    <View style={getStyles(['floatingWidgetMainContainer', `floatingWidgetMainContainer_${listItemData[0]?.widgetMetaHtmlId}`])} id={`floatingWidgetMainContainer floatingWidgetMainContainer_${listItemData[0]?.widgetMetaHtmlId}`}>
      <CustomFlatList
        nestedScrollEnabled={true}
        data={listItemData}
        renderItem={renderItem}
        keyExtractor={item => item?.widgetId?.toString()}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={getStyles(['floatingWidgetFlatListContentContainer'])}
      />
    </View>
  );
})

export default FloatingWidget